import { on, off, fire } from "delegated-events";
import requestTimeout from '../common/requestTimeout'

const init = () => {
    const clickArgs = ["click", '[data-tablist] [role="tab"]', handleTab];

    off(...clickArgs);
    on(...clickArgs);
};

const closeOtherTabs = (activeTrigger) => {
    const container = activeTrigger.closest('[role="tablist"]');
    const otherTriggers = Array.from(container.querySelectorAll('[role="tab"][aria-selected="true"]')).filter(
        (x) => x !== activeTrigger,
    );

    otherTriggers.forEach((x) => closeTab(x));
};

const openTab = (trigger) => {
    const panel = document.getElementById(trigger.getAttribute("aria-controls"));

    trigger.setAttribute("aria-selected", "true");
    panel.setAttribute("aria-hidden", "false");


    requestTimeout(() => {
        panel.classList.toggle("opacity-0");
    }, 200);

    fire(document.documentElement, "tablist:tabshow", { panelEl: panel });
};

const closeTab = (trigger) => {
    const panel = document.getElementById(trigger.getAttribute("aria-controls"));

    trigger.setAttribute("aria-selected", "false");
    panel.setAttribute("aria-hidden", "true");
    panel.classList.toggle("opacity-0");
};

const animateAllTabMarkers = () => {
    document.querySelectorAll('[data-tablist="animate"]').forEach(tablist => animateTabMarker(tablist));
};

const animateTabMarker = (tablist) => {
    const selectedTab = tablist.querySelector('[role="tab"][aria-selected="true"]');
    if (selectedTab) {
        const marker = tablist.querySelector(".marker");
        marker.style.left = `${selectedTab.offsetLeft}px`;
        marker.style.width = `${selectedTab.offsetWidth}px`;
    }
};

const handleTab = (e) => {
    e.preventDefault();

    const trigger = e.target.closest('[role="tab"]');
    const practiceID = trigger.getAttribute('data-practice-id');
    const view = trigger.getAttribute('data-view');
    const tablist = document.querySelector(`.Practice-${practiceID}.View-${view}`);

    if (trigger.getAttribute("aria-selected") === "false") {
        openTab(trigger);
        closeOtherTabs(trigger);
    }
};

export default {
    can: () => document.querySelector('[data-tablist] [role="tab"]'),
    run: () => { init(); }
};
